// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "c9efcea60911b709",
    "hash": "c9efcea60911b709",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c9efcea60911b709",
    "semverString": null,
    "version": "0.0.0"
};
/* tslint:enable */
